<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户详细信息</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-row>
        <el-col>
          <span>客户名称: {{customer.name}}&nbsp;&nbsp;&nbsp;&nbsp; 当前账户余额: {{customer.balance}}</span>
        </el-col>
      </el-row>
    </layout-panel>

    <el-row>
      <router-link :to="{ path: '/teke_customer/recharge/form/'+search.customerid+'?customername='+customer.name}">
        <el-button type="primary">客户充值</el-button>
      </router-link>

      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="customerid"
                         label="客户ID"></el-table-column>
        <el-table-column prop="amount"
                         label="充值金额"></el-table-column>
        <el-table-column prop="updatetime"
                         label="充值时间"></el-table-column>
        <el-table-column prop="imageurl"
                         label="转账截图">
          <template slot-scope="scope">
            <a :href="scope.row.imageurl"
               target="_Blank"
               v-if="scope.row.imageurl">
              <img :src="scope.row.imageurl+'?x-oss-process=image/resize,w_100/auto-orient,1'"
                   width="100px;"
                   height="100px;">
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="is_allow_invoice"
                         label="允许开票">
          <template slot-scope="scope">
            <span v-if="scope.row.is_allow_invoice === '0' ">允许</span>
            <span v-if="scope.row.is_allow_invoice === '1' ">不允许</span>
          </template>
        </el-table-column>
        <el-table-column prop="invoice_id"
                         label="开票记录"></el-table-column>
        <el-table-column prop="desc"
                         label="备注"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        customerid: this.$route.params.id,
      },
      // 搜索字段申明
      searchFieldType: {
        customerid: Number,
      },
      customer: {
        name: this.$route.query.customername,
        balance: null,
      },

    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.getCustomerBalance()
  },
  methods: {
    ...Vuex.mapActions(['getTekeCustomerRechargeTable', 'getTekeCustomerBalance']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getTekeCustomerRechargeTable', params)
    },
    getCustomerBalance () {
      return request.page('getTekeCustomerBalance', this.search.customerid).then(({data}) => {
        filter.setLoop(this.customer, data)
      })
    },
    formatUnix (time) {
      return filter.formatUnix(time)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/teke-customer/pages/TekeCustomerRechargeTable.vue